import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { TenantSummary } from '@/common/models';
import { FormatHelper, PaginationHelper } from '@/common/helpers';
import { Pagination } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Pagination,
  },
})
export default class TenantsList extends Vue {
  readonly pageSizeOptions: string[] = ['50', '100', '200'];

  @Prop({ required: true }) tenants!: TenantSummary[];
  @Prop({ required: true }) currentPage!: number;

  pageSize: number = 50;

  headers: any = [
    { text: 'Tenancy name', value: 'name' },
    { text: 'Requester email', value: 'email' },
    { text: 'CIDN', value: 'cidn' },
    { text: 'Date created', value: 'createdAtUtc' },
    { text: 'Date updated', value: 'modifiedAtUtc' },
  ];

  get items(): any[] {
    return this.tenants ? this.tenants : [];
  }

  get pages(): number {
    return PaginationHelper.pages(this.items, this.pageSize);
  }

  get showPagination(): boolean {
    return PaginationHelper.showPagination(this.items, this.pageSizeOptions);
  }

  get canPrevious(): boolean {
    return PaginationHelper.canPrevious(this.currentPage);
  }

  get canNext(): boolean {
    return PaginationHelper.canNext(this.currentPage, this.pages);
  }

  pageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
  }

  @Emit()
  pageChange(pageNumber: number) {
    this.$emit('pageChange', pageNumber);
  }

  @Emit()
  tenantClicked(item: TenantSummary): void {
    this.$emit('tenantClicked', item.tenantId);
  }

  formatDate(date: Date): string {
    return date ? FormatHelper.formatDate(date.toString()) : '';
  }
}
